@use '../../ui-library/styles/themed' as themed;
@use '../../ui-library/styles/border' as border;
@use '../../ui-library/styles/shadow' as shadow;
@use '../../ui-library/styles/typography' as typography;

@keyframes slideInFromBottom {
  from {
    transform: translateY(16px) scale(0.96);
    opacity: 0;
    filter: blur(1px);
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
    filter: blur(0);
  }
}

@keyframes slideInFromTop {
  from {
    transform: translateY(-16px) scale(0.96);
    opacity: 0;
    filter: blur(1px);
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
    filter: blur(0);
  }
}

.container {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;

  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

.containerTop {
  top: 54px;
}

.containerBottom {
  bottom: 24px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 16px;
  width: fit-content;
  max-width: calc(100vw - 32px);
  overflow: clip;

  border: border.$border-width solid themed.color(border-default);
  border-radius: 12px;
  box-shadow: shadow.$shadow-m;

  animation-duration: 230ms;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

.fromBottom {
  animation-name: slideInFromBottom;
}

.fromTop {
  animation-name: slideInFromTop;
}

.inline {
  max-width: 100%;
}

.dark {
  background-color: themed.color(surface-default);
}

.light {
  background-color: themed.color(surface-full);
}

.s {
  padding: 8px;

  .content {
    gap: 6px;
  }
}

.m {
  padding: 10px;

  .content {
    gap: 6px;
  }
}

.l {
  padding: 12px;

  .content {
    gap: 8px;
  }
}

.content {
  display: flex;
  flex: 1 0 0;
  align-items: flex-start;
  min-width: 0;
  padding-left: 4px;
}

.iconContainer {
  display: flex;
  align-items: center;
  padding: 4px 0;
  flex-shrink: 0;

  &.success {
    color: themed.color(tag-green-default);
  }

  &.warning {
    color: themed.color(tag-amber-highlight);
  }

  &.error {
    color: themed.color(tag-red-default);
  }

  &.info {
    color: themed.color(icon-primary);
  }
}

.textContainer {
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  padding: 0 4px;
}

.title {
  @include typography.text-m-medium;
  color: themed.color(text-primary);
  padding: 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-wrap: balance;
}

.description {
  @include typography.text-s-regular;
  color: themed.color(text-secondary);
  width: 100%;
  text-wrap: pretty;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.actions .dismissButton {
  color: themed.color(icon-tertiary);
}
